import { injectable } from "inversify";
import { ITracker } from "../../domain/interfaces/tracker.interface";
import { ITrackingEvent } from "../../domain/interfaces/tracking-event.interface";

@injectable()
export class NullTracker implements ITracker {
	public async trackEvent(trackingEvent: ITrackingEvent): Promise<void> {
		// Placeholder
	}

}
